export const findFormWrapper = () => {
	const FORM_WRAPPER_SELECTORS = ['#form'] as const;

	for (const selector of FORM_WRAPPER_SELECTORS) {
		const element = document.querySelector(selector);
		if (element) return element;
	}
	return null;
};
